const TONE = {
  grey: "bg-slate-100 text-slate-600",
  amber: "bg-amber-50 text-[#B45309]",
  red: "bg-red-50 text-[#C2261D]",
  green: "bg-green-50 text-[#15803D]",
};

const daysTo = (iso) => {
  if (!iso) return null;
  const t = new Date(); t.setHours(0, 0, 0, 0);
  return Math.round((new Date(`${String(iso).slice(0, 10)}T00:00:00`) - t) / 86400000);
};

// Selo à direita da linha de contexto: «Escritura 18 d» (cinzento; âmbar ≤7 d; vermelho ≤3 d ou com bloqueio); sem escritura, a fase.
export function seloOf({ deedDate, block, card }) {
  const n = daysTo(deedDate);
  if (n != null && n >= 0) return { text: n === 0 ? "Escritura hoje" : `Escritura ${n} d`, tone: block || n <= 3 ? "red" : n <= 7 ? "amber" : "grey" };
  if (!card) return null;
  if (card.corner?.big === "CMI") return { text: `CMI ${card.corner.small}`, tone: card.corner.tone === "green" ? "green" : "grey" };
  if (card.corner?.small === "escriturado") return { text: "Escriturado", tone: "green" };
  return { text: card.phase_label, tone: (card.blocks || []).length ? "red" : "grey" };
}

// Linha de contexto numa só linha: morada curta (corta com «…») + selo (nunca corta).
// No computador (lg): tight = selo logo a seguir à morada (se não couber, desce; a morada nunca corta); wrap = morada inteira; big = selo a 14 px.
export function ContextLine({ where, selo, testid, className = "", tight = false, wrap = false, big = false }) {
  const w = tight ? "flex-1 min-w-0 truncate lg:flex-none lg:max-w-full lg:whitespace-normal lg:overflow-visible"
    : `flex-1 min-w-0 ${wrap ? "truncate lg:whitespace-normal lg:overflow-visible" : "truncate"}`;
  return (
    <div className={`flex items-center gap-2 min-w-0 ${tight ? "lg:flex-wrap lg:gap-y-1" : ""} ${wrap ? "lg:items-start" : ""} ${className}`} data-testid={testid}>
      <span className={w} data-testid={`${testid}-where`}>{where}</span>
      {selo && <span className={`shrink-0 whitespace-nowrap text-[12px] ${big ? "lg:text-sm" : ""} font-semibold px-2 py-0.5 rounded-full ${TONE[selo.tone] || TONE.grey}`} data-testid={`${testid}-selo`}>{selo.text}</span>}
    </div>
  );
}
